import { connect } from 'react-redux'
import { compose, withHandlers, withProps, withState } from 'recompose'
import toggle from 'components/common/hoc/toggle'
import withViewHide from 'components/common/hoc/withViewHide'
import { formatPhoneNumber } from 'helpers/phone-number'
import { showStoreLocatorModalInAppointmentMode } from 'actions/storeLocator'
import { showPromotionsDetailModalPage } from 'components/PromotionsDetailModalPage/actions'
import { getProductPromotions } from './helpers'
import { NOT_STAGGERED_TIRE_TYPE, OTDP_MESSAGE_PHONE_REPLACE } from './constants'
import Product from './Product'
import withPromoModal from 'components/common/hoc/withPromoModal'
import { getActiveVehicleName, getActiveVehicleId } from 'selectors/getActiveVehicle'
import { addSaveForLaterItemAction, handleProductClickAction } from '../actions'
import { setAvailabilityData } from 'actions/shoppingData'
import { setSkusAddedToCart } from 'components/common/hoc/withAddToQuote/actions.js'
import { INVENTORY_STATUS_LOADED } from 'components/common/UpdatingBlock/constants.js'
import { removeSkuAddedToCart } from 'components/common/hoc/withAddToQuote/actions'
import { getUserData } from 'components/Appointment/selectors'

const mapStateToProps = ({ myStore, ...state }, { product: { tireType } = {}}) => {
  const { isPilotStore } = getUserData(state)

  return {
    myStore,
    isStaggeredSku: tireType && tireType !== NOT_STAGGERED_TIRE_TYPE,
    storePhoneNumber: myStore ? myStore.phoneNumbers[0] : undefined,
    formattedStorePhoneNumber: myStore ? formatPhoneNumber(myStore.phoneNumbers[0]) : undefined,
    vehicleName: getActiveVehicleName(state),
    inventoryStatuses: state.updatingBlocks[INVENTORY_STATUS_LOADED],
    isPilotStore,
    activeVehicleId: getActiveVehicleId(state)
  }
}

const withProductProps = withProps(({
  formattedStorePhoneNumber,
  myStore,
  otdPricingToolTipMessage = '',
  product,
  product: { promotions = [], otdpAddons = []}
}) => ({
  showOtdpMessage: Boolean(myStore && !otdpAddons.length),
  otdpMessage: otdPricingToolTipMessage.split(OTDP_MESSAGE_PHONE_REPLACE),
  productPromotions: getProductPromotions(product),
  instantSavingsPromotions: promotions.filter(({ promotionRebate } = {}) => !promotionRebate)
}))

const withToggle = compose(
  withProps({ expandedByDefault: true }),
  toggle
)

const withHiddenState = withViewHide(({
  product: {
    available
  } = {},
  expanded
}) => !available && !expanded
)

const withSaveForLaterState = withState('isSavedForLater', 'setIsSavedForLater', false)

const withSaveForLaterHandler = withHandlers({
  handleSaveForLater: (
    {
      product: { commerceItemId, qty, bvId },
      addSaveForLaterItemAction,
      isSavedForLater,
      setIsSavedForLater,
      product,
      removeSkuAddedToCart
    }) => () => {
    setIsSavedForLater(!isSavedForLater)
    removeSkuAddedToCart(bvId)
    setTimeout(() => {
      addSaveForLaterItemAction(commerceItemId, String(qty), product)
    }, 1000)
  }
})

const withClickHandlers = withHandlers({
  handleProductClick: ({ product, handleProductClickAction }) => () => {
    handleProductClickAction({ product })
  }
})

export default compose(
  connect(mapStateToProps, {
    addSaveForLaterItemAction,
    showStoreLocatorModalInAppointmentMode,
    showPromotionsDetailModalPage,
    handleProductClickAction,
    setAvailability: setAvailabilityData,
    setSkusAddedToCart,
    removeSkuAddedToCart
  }),
  withSaveForLaterState,
  withToggle,
  withPromoModal,
  withHiddenState,
  withProductProps,
  withSaveForLaterHandler,
  withClickHandlers
)(Product)
